import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_9 = { class: "border p-2 p-lg-4 border-dark border-opacity-10" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 m-10 text-decoration-none",
          to: "/liste_attribution"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Liste des attributions ", -1),
            _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("table", _hoisted_13, [
                        _createElementVNode("thead", null, [
                          _cache[7] || (_cache[7] = _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              scope: "col",
                              class: "text-left fs-18 pt-0",
                              colspan: "2"
                            }, " Information de l'attrbution ")
                          ], -1)),
                          _createElementVNode("tr", null, [
                            _cache[1] || (_cache[1] = _createElementVNode("th", {
                              scope: "col",
                              class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, " Numéro Attribution ", -1)),
                            _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.retourInfo.attributionId), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[2] || (_cache[2] = _createElementVNode("th", {
                              scope: "col",
                              class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, " Date ", -1)),
                            _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.format_Date(_ctx.retourInfo.dateAttr)), 1)
                          ]),
                          _cache[8] || (_cache[8] = _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              scope: "col",
                              class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, " Type "),
                            _createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-primary" }, " Attribution ")
                          ], -1)),
                          _createElementVNode("tr", null, [
                            _cache[3] || (_cache[3] = _createElementVNode("th", {
                              scope: "col",
                              class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, " Agent concerné ", -1)),
                            _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.retourInfo.agent), 1)
                          ]),
                          (_ctx.retourInfo.depotId!)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                                _cache[4] || (_cache[4] = _createElementVNode("th", {
                                  scope: "col",
                                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, " Dépot ", -1)),
                                _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.retourInfo.montantDepot), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.retourInfo.paiementId!)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                                _cache[5] || (_cache[5] = _createElementVNode("th", {
                                  scope: "col",
                                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, " Paiement ", -1)),
                                _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.retourInfo.montantPayer), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("tr", null, [
                            _cache[6] || (_cache[6] = _createElementVNode("th", {
                              scope: "col",
                              class: "text-uppercase text-left fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, " Intervalles Attribués ", -1)),
                            _createElementVNode("td", _hoisted_21, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.retourInfo.intervalles, (attr, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: index,
                                  class: "badge text-bg-success fs-13 m-2 mr-4"
                                }, _toDisplayString(attr.numDebut + " -- " + attr.numFin), 1))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}